<script lang="ts">
    import {Link} from 'svelte-routing'
    import IconifyIcon from '@iconify/svelte'
    import userIcon from '@iconify/icons-fa-solid/user-alt'
    import heroIcon from '@iconify/icons-fa-solid/dragon'
    import membershipIcon from '@iconify/icons-fa-solid/crown'
    import runIcon from '@iconify/icons-fa-solid/running'
    import cogIcon from '@iconify/icons-fa-solid/cog'
    import stakingIcon from '@iconify/icons-fa-solid/coins'
    import {getStakingBalance} from 'src/components/cabinet/#services/staking'

    let url = window.location.pathname
</script>

<div class="navbar">
    <Link to="inventory" class="navbar-link notranslate">
        <div class:active={url.includes('/inventory')}>
            <div class="navbar-icon"><IconifyIcon icon={heroIcon}/></div>
            <div>Inventory</div>
        </div>
    </Link>
    <Link to="activity" class="navbar-link notranslate">
        <div class:active={url.includes('/activity')}>
            <div class="navbar-icon"><IconifyIcon icon={runIcon}/></div>
            <div>Activity</div>
        </div>
    </Link>
    <Link to="account" class="navbar-link notranslate">
        <div class:active={url.includes('/account')}>
            <div class="navbar-icon"><IconifyIcon icon={userIcon}/></div>
            <div>Account</div>
        </div>
    </Link>
    {#if $getStakingBalance.hasValue && $getStakingBalance.value?.isUserParticipate}
<!--    <Link to="staking" class="navbar-link notranslate">-->
<!--        <div class:active={url.includes('/staking')}>-->
<!--            <div class="navbar-icon"><IconifyIcon icon={stakingIcon}/></div>-->
<!--            <div>Staking</div>-->
<!--        </div>-->
<!--    </Link>-->
    {/if}
    <Link to="/settings" class="navbar-link notranslate">
        <div class:active={url.includes('/settings')}>
            <div class="navbar-icon"><IconifyIcon icon={cogIcon}/></div>
            <div>Settings</div>
        </div>
    </Link>
</div>

<style>
    .navbar {
        display: none;
        justify-content: space-between;
        position: fixed;
        width: 100%;
        height: 60px;
        left: 0;
        bottom: 0;
        right: 0;
        z-index: 4;
        padding: 0;
        background: #25234c;
        border-top: 2px solid #312d61;
    }

    .navbar :global(.navbar-link) {
        width: 20%;
        height: 100%;
        font-size: 11px;
        color: #b6b4d9;
        text-align: center;
        text-decoration: none;
        line-height: 15px;
        padding: 8px 0;
    }

    .navbar :global(.navbar-link div:not(.navbar-icon)) {
        width: 100%;
    }

    .navbar-icon {
        height: 28px;
        width: 28px;
        margin: 0 auto 1px;
        font-size: 18px;
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 4px;
    }

    .navbar :global(.navbar-link .active) {
        color: white;
        font-weight: 600;
    }

    @media(max-width: 767px) {
        .navbar {
            display: flex;
        }
    }
</style>
